import {
  ExchangeType,
  LoginParams,
  toSearchParams,
} from '@collab/libs/auth/authTypes';

import { backendApiBaseUrl, parseData } from 'libs/api';
import authFetch, { nextServerAuthFetch } from 'libs/auth-fetch';
import { ApiInfo } from 'libs/cms/common/types';
import { normalizeVolvoIdToken } from 'libs/volvoId/models';

import { normalizeApiInfo } from './normalizeData';

type ExportFormat = 'yaml-link' | 'json-link';

const getExportedApiSpecUrl = async (
  format: ExportFormat,
  azureId: string,
): Promise<string | null> => {
  const response = await fetch(
    `${backendApiBaseUrl}/apim/apis/${azureId}/export?exportFormat=${format}`,
  );

  if (response.status === 404) {
    return null;
  }

  const { fileUrl } = await parseData(response, 200);

  return fileUrl;
};

export const getExportedApiSpec = async (
  format: ExportFormat,
  azureId: string,
) => {
  const fileUrl = await getExportedApiSpecUrl(format, azureId);

  if (!fileUrl) return null;

  const response = await fetch(fileUrl);

  return parseData(response, 200);
};

export const getVolvoIdTokenDemo = async (apiId: string) => {
  const response = await authFetch(`/demo-token/${apiId}`);

  if (response.status === 404) {
    return null;
  }

  const data = await parseData(response, 200);

  return normalizeVolvoIdToken(data);
};

export const getVolvoIdApimLoginUrl = async (
  apiId: string,
  params: LoginParams,
): Promise<string> => {
  const searchParams = toSearchParams(params);

  const response = await authFetch(
    `/authorize-my-car/login/${apiId}?${searchParams}`,
  );

  const data = await parseData(response, 200);

  return data.loginUrl;
};

export const exchangeVolvoIdApimToken = async (body: ExchangeType) => {
  const response = await authFetch(`/authorize-my-car/exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await parseData(response, 201);

  return normalizeVolvoIdToken(data);
};

export const getApi = async (apiId: string): Promise<ApiInfo> => {
  const response = await nextServerAuthFetch(`/api/apim/apis/${apiId}`);

  const data = await parseData(response, 200);

  return normalizeApiInfo(data.api);
};
